module.exports = __webpack_public_path__ + "img/social_value_content2.0da5c249.png";